// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1VbVK","info":"PatientInfo_info__1qfD4"};